import * as React from 'react'

import { Box, Icon, Link, Text } from '@factorialco/deprecated-design-system'

interface Props {
  icon: React.ComponentProps<typeof Icon.Large>['icon']
  title: string
  description: string
  linkText: string
  onClick: () => void
}

const OnboardingBox = ({ icon, title, description, linkText, onClick }: Props) => {
  return (
    <Box
      textAlign="left"
      borderRadius={{ all: 'abs008' }}
      background="grey200"
      gap="s16"
      padding="s24"
      width="s360"
    >
      <Icon.Large icon={icon} color="grey800" />
      <Text.Normal weight="semibold">{title}</Text.Normal>
      <Text size="200">{description}</Text>
      <Link.Touchable onClick={onClick}>{linkText}</Link.Touchable>
    </Box>
  )
}

export default OnboardingBox
